const ReportBug = ({ changeSettingsPage }) => {
  return (
    <div className="accountSettingsCard">
      <h3 className="accountSettingsCardTitle">Report Bug/Feedback</h3>
      <p className="accountSettingsToggleDescription">
        Noticed a bug or have something to share with us? Let us know here.
      </p>
      <button
        className="accountSettingsButton"
        onClick={() => changeSettingsPage("ReportBug/Feedback")}
      >
        Report Bug/Feedback
      </button>
    </div>
  );
};

export default ReportBug;
